import { StoreItemEnum as t } from "../../../enums/store-item-enum.mjs";
const o = {
  type: t.optin,
  title: "Subscribe to our newsletter",
  subTitle: `Get the latest news and updates \r
from our store!`,
  buttonTitle: "Subscribe",
  fields: [],
  thumbnail: null,
  thankYouPage: {
    title: "Thank you!",
    text: `Thank you for your subscription! \r
And have a good day!`
  }
};
export {
  o as defaultOptinValues
};
